// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

import '../../css/pages/PixelAudience.styl'
// components
import { Card, Columns, LineChart, Form } from '@st-operations/uikit/src/v2/index.js'
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const PixelAudience = (props) => {
  useRetractSidebar()

  return (
    <div id="pixel-audience-page">
      <EntityEditForm
        entities="pixel-audiences"
        id={props.match.params.id}
        resource="Pixel Audiences"
      >
        {({ disabled, item, onChange, schema }) => (
          <div>
            <Columns classes={{ root: 'pixel-audience-column-form' }}>
              <Form
                item={item}
                onChange={onChange}
                schema={schema}
                fields={[
                  { name: 'name' },
                  { name: 'company' },
                  { name: 'redirect' },
                  { name: 'vertical' },
                  { name: 'action' },
                  { name: 'uid', label: 'Unique Identifier' },
                ]}
                disabled={disabled}
              />
              <Form
                item={item}
                onChange={onChange}
                schema={schema}
                fields={[{ name: 'embed_code', className: 'code' }]}
                disabled={disabled}
              >
                <If condition={Object.keys(item.mau || {}).length > 0}>
                  <Card className="line-chart-wrapper">
                    <LineChart
                      color="green"
                      data={item.mau || {}}
                      height={281}
                      padding={0}
                      title="Monthly Active Users"
                      width={750}
                      y_axis_gutter={70}
                      x_axis_gutter={20}
                    />
                  </Card>
                </If>
                <If condition={Object.keys(item.dau || {}).length > 0}>
                  <Card className="line-chart-wrapper">
                    <LineChart
                      color="green"
                      data={item.dau || {}}
                      height={281}
                      padding={0}
                      title="Daily Active Users"
                      width={750}
                      y_axis_gutter={70}
                      x_axis_gutter={20}
                    />
                  </Card>
                </If>
              </Form>
            </Columns>
          </div>
        )}
      </EntityEditForm>
    </div>
  )
}

export default PixelAudience
